import {Map, fromJS, List} from "immutable";

import {DELIVERY_NOTES_STATS_REQUEST, DELIVERY_NOTES_STATS_SUCCESS, DELIVERY_NOTES_STATS_ERROR, CLEAN_DELIVERY_NOTES_STATS_STATE} from "./delivery-notes-stats-actions";

const deliveryNotesStats = (state = Map({
    payload: List([]),
    isFetching: false,
    error: false
}), action) => {
    let newState;
    switch (action.type) {

        // Requests
        case DELIVERY_NOTES_STATS_REQUEST:
            newState = state.merge({
                isFetching: true,
                error: false
            });
            return newState;

        // Success
        case DELIVERY_NOTES_STATS_SUCCESS:
            newState = state.merge({
                payload: fromJS(action.payload),
                isFetching: false,
                error: false
            });
            return newState;

        // Errors
        case DELIVERY_NOTES_STATS_ERROR:
            newState = state.merge({
                isFetching: false,
                error: action.error,
                errorMessage: action.errorMessage
            });
            return newState;

        // Clean state
        case CLEAN_DELIVERY_NOTES_STATS_STATE:
            newState = state.merge({
                payload: undefined,
                isFetching: false,
                error: false
            });
            return newState;

        default:
            return state;
    }
};

export default deliveryNotesStats;